import { render } from "./MainCommissions.vue?vue&type=template&id=ebe43832&scoped=true"
import script from "./MainCommissions.vue?vue&type=script&lang=js"
export * from "./MainCommissions.vue?vue&type=script&lang=js"

import "./MainCommissions.vue?vue&type=style&index=0&id=ebe43832&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebe43832"]])

export default __exports__